function adjustMenu() {
    const $ul = $('.magazine .filter-nav > ul');
    const $lis = $ul.find('li');
    const maxItems = 5;

    if ($(window).width() >= 992) {
        if ($lis.length > maxItems) {
            let $moreMenu = $ul.find('.more-menu');
            if ($moreMenu.length === 0) {
                $moreMenu = $('<li class="more-menu"><a href="#">More <img src="/wp-content/themes/regionalhealth/assets/images/magazine/icons-arrow-left-gold.svg" alt=""></a><ul class="dropdown-menu"></ul></li>').appendTo($ul);
            }
            $moreMenu.find('.dropdown-menu').empty();

            $lis.not(':nth-child(-n+' + maxItems + '), .more-menu').appendTo($moreMenu.find('.dropdown-menu'));
            $moreMenu.find('> a').off('click').on('click', function(e) {
                e.preventDefault();
                var $dropdown = $(this).next('.dropdown-menu');
                $dropdown.toggleClass('visible');
            });
        }
    } else {
        $ul.find('.dropdown-menu > li').appendTo($ul);
        $ul.find('.more-menu').remove();
    }
}


$(document).on('click', function(e) {
    var $moreMenu = $('.more-menu');
    if (!$moreMenu.is(e.target) && $moreMenu.has(e.target).length === 0) {
        $('.dropdown-menu').removeClass('visible');
    }
});

$('.filter-nav .search button').on('click', function(e) {
    e.preventDefault();
    $(this).hide();
    $('.filter-nav ul').toggleClass('toggle-search');
    $('.magazine-search').toggleClass('show-form');
    $('.dropdown-menu').removeClass('visible');
    e.stopPropagation();
    setTimeout(function() {
        $('#search-magazine').focus();
    }, 100);
});

$('.btn-close').on('click', function(e) {
    $('.filter-nav .search button').show();
    $('.magazine-search').toggleClass('show-form');
    $('.filter-nav ul').toggleClass('toggle-search');
});

$(document).on('click', function(event) {
    if (!$(event.target).closest('.magazine-search').length) {
        $('.magazine-search.show-form').removeClass('show-form');
        $('.filter-nav ul').removeClass('toggle-search');
        $('.filter-nav .search button').show();
    }
});

$('.divider-top').each(function() {
    var $h2 = $(this).nextUntil('.divider-bottom').filter('h2').first();
    if ($h2.length) {
        $h2.nextAll('p').first().addClass('accordion-paragraph');
    }
});

let searchInput = $('#search-magazine'),
    searchForm = $('#search-form'),
    searchResults = $('#search-results-container');

let debouncedSearch = _.debounce(function() {
    searchArticles();
}, 300);

searchInput.on('keyup', function() {
    if($(this).val().length < 2) return;
    debouncedSearch();
});

searchForm.on('submit', function(e) {
    e.preventDefault();
    searchArticles();
});

function searchArticles() {
    searchResults.show();
    let data = new FormData();
    data.append('action', 'search_articles');
    data.append('query', searchInput.val());

    axios.post('/wp-admin/admin-ajax.php', data)
        .then(function(response) {
            if (searchInput.val().trim() === '') {
                searchResults.hide();
                return;
            }
            if(response.data.success && response.data.data.results && response.data.data.results.length > 0) {
                searchResults.empty();
                let newResults = '';
                response.data.data.results.forEach(function(resultItem) {
                    newResults += '<a href="' + resultItem.url + '">' + resultItem.title + '</a>';
                });
                searchResults.html(newResults);
            } else {
                searchResults.html('<p>No results found.</p>');
            }
        }).catch(function(error) {
        searchResults.html('<p>Error while searching. Please try again.</p>');
    });
}

adjustMenu();
$(window).on('resize', adjustMenu);
function positionFullImages() {
    let containerWidth = $('.main-magazine-image').outerWidth(),
        copyColWidth = $('.magazine-article').outerWidth(),
        gutterWidth = (containerWidth - copyColWidth) / 2 + 20;

    $('.size-full').css({
        // 'margin-left': 0 - gutterWidth,
        // 'margin-right': 0 - gutterWidth,
        // 'width': containerWidth,
        // 'height': '100%',
        // 'max-width':'initial'
    });
}
// positionFullImages();

$(window).on('resize', function () {
    // positionFullImages();
});

var magazineShowHeader = document.querySelector('.magazine-top button');
if (magazineShowHeader) {
    magazineShowHeader.addEventListener('click', function() {
        if ($(window).width() >= 991) {
            $('.navbar-primary .nav-item-dropdown').addClass('disable-hover');
        }
        var siteHeader = document.querySelector('.site-header');
        if (siteHeader) {
            siteHeader.classList.toggle('show-original-header');
        }
        magazineShowHeader.classList.toggle('active-button');


        setTimeout(function() {
            $('.navbar-primary .nav-item-dropdown').removeClass('disable-hover');
        }, 1000);

    });
}